import { Card, Group, Stack, Text } from "@/components/ui";
import type { ProveedorAdmin } from "@/lib/types";
import { EstadoBadge } from "./ProveedorBadge";

/**
 * Vista de card para mobile · solo lectura. Para edición / baja /
 * reactivación se invita a abrir la app en pantalla mediana o mayor
 * (los inputs inline no caben bien en mobile).
 */
export function ProveedorMobileCard({ prov }: { prov: ProveedorAdmin }) {
  return (
    <Card padding="md">
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <div className="min-w-0 flex-1">
            <Group gap={6} align="baseline">
              <Text ff="mono" size="xs" c="dimmed">
                #
              </Text>
              <Text ff="mono" fw={500} size="sm">
                {prov.numeroProveedor}
              </Text>
              <Text size="xs" c="dimmed" ff="mono">
                {prov.rfc}
              </Text>
            </Group>
            <Text fw={500} truncate className="mt-0.5">
              {prov.razonSocial}
            </Text>
          </div>
          <EstadoBadge activo={prov.estaActivo} />
        </Group>
        <div className="grid grid-cols-2 gap-1">
          <Text size="xs" c="dimmed">
            Banco
          </Text>
          <Text size="xs" ta="right">
            {prov.datosBancarios.banco}
          </Text>
          <Text size="xs" c="dimmed">
            Cuenta
          </Text>
          <Text size="xs" ta="right" ff="mono">
            {prov.datosBancarios.cuenta}
          </Text>
          {prov.datosBancarios.clabe ? (
            <>
              <Text size="xs" c="dimmed">
                CLABE
              </Text>
              <Text size="xs" ta="right" ff="mono" style={{ fontSize: 11 }}>
                {prov.datosBancarios.clabe}
              </Text>
            </>
          ) : null}
        </div>
        <Text size="xs" c="dimmed" style={{ fontSize: 10 }}>
          Para editar/dar de baja, abre el portal en pantalla mediana o mayor.
        </Text>
      </Stack>
    </Card>
  );
}
